/**
/* This file is generated by Mochitype. Do not edit it by hand.
/**/

import { z } from "zod";

export const DiscoverFeed = z.object({
  id: z.number(),
  prompt: z.string().nullable(),
  created_at: z.string(),
  status: z.string(),
});

export type TDiscoverFeed = z.infer<typeof DiscoverFeed>;

export const AppliedResearchArea = z.object({
  name: z.string(),
});

export type TAppliedResearchArea = z.infer<typeof AppliedResearchArea>;

export const Organization = z.object({
  type: z.string(),
  id: z.number(),
  name: z.string().nullable(),
  domain: z.string().nullable(),
  description: z.string().nullable(),
  logo_url: z.string().nullable(),
});

export type TOrganization = z.infer<typeof Organization>;

export const PrimaryContactImageMedium = z.object({
  url: z.string().nullable(),
});

export type TPrimaryContactImageMedium = z.infer<typeof PrimaryContactImageMedium>;

export const PrimaryContactImage = z.object({
  medium: PrimaryContactImageMedium,
});

export type TPrimaryContactImage = z.infer<typeof PrimaryContactImage>;

export const PrimaryContactUser = z.object({
  id: z.number(),
  name: z.string(),
  image: PrimaryContactImage,
});

export type TPrimaryContactUser = z.infer<typeof PrimaryContactUser>;

export const ExtraData = z.object({
  relevance_reason: z.string().nullable(),
  detailed_relevance_reason: z.string().nullable(),
});

export type TExtraData = z.infer<typeof ExtraData>;

export const Prediction = z.object({
  score: z.number().nullable(),
  extra_data: ExtraData.nullable(),
});

export type TPrediction = z.infer<typeof Prediction>;

export const SolutionListing = z.object({
  id: z.number(),
  external_id: z.string(),
  slug: z.string().nullable(),
  title: z.string(),
  summary: z.string().nullable(),
  description: z.string().nullable(),
  listing_type: z.string().nullable(),
  image_url: z.string().nullable(),
  image: z.string().nullable(),
  technology_readiness_level: z.number().nullable(),
  technology_readiness_label: z.string().nullable(),
  partnership_models: z.array(z.string()).nullable(),
  applied_research_areas: z.array(AppliedResearchArea).nullable(),
  created_at: z.string().nullable(),
  organization: Organization,
  primary_contact_user: PrimaryContactUser.nullable(),
  prediction: Prediction.nullable(),
});

export type TSolutionListing = z.infer<typeof SolutionListing>;

export const ImageHash = z.object({
  url: z.string().nullable(),
});

export type TImageHash = z.infer<typeof ImageHash>;

export const AvatarImageHash = z.object({
  url: z.string().nullable(),
  big: ImageHash,
  medium: ImageHash,
  small: ImageHash,
});

export type TAvatarImageHash = z.infer<typeof AvatarImageHash>;

export const University = z.object({
  name: z.string(),
  slug: z.string(),
});

export type TUniversity = z.infer<typeof University>;

export const ProfileInfo = z.object({
  id: z.number(),
  headline: z.string().nullable(),
  about: z.string().nullable(),
  research_areas: z.array(z.string()).nullable(),
  title: z.string().nullable(),
  location: z.string().nullable(),
  university: University.nullable(),
  is_university_scientist: z.boolean(),
  is_startup_scientist: z.boolean(),
  is_in_network: z.boolean().nullable(),
});

export type TProfileInfo = z.infer<typeof ProfileInfo>;

export const Innovator = z.object({
  id: z.number(),
  image: AvatarImageHash,
  name: z.string(),
  profile_id: z.string(),
  profile_info: ProfileInfo,
  prediction: Prediction.nullable(),
});

export type TInnovator = z.infer<typeof Innovator>;

export const Show = z.object({
  discover_feed: DiscoverFeed,
  listings: z.array(SolutionListing),
  innovators: z.array(Innovator),
});

export type TShow = z.infer<typeof Show>;
